import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';;
import { API_URL } from '../../configurations/server-config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getAccount(page = 0, size = 10): Observable<any> {
    return this.http.get(`${API_URL}/account?page=${page}&size=${size}`);
  }

  getRole(): Observable<any> {
    return this.http.get(`${API_URL}/rolelist`);
  }

  saveuser(value: any): any {
    return this.http.post(`${API_URL}/createuser`, value);
  }

  getuserinfo(id: any): Observable<any> {
    return this.http.get(`${API_URL}/getuserinfo/${id}`);
  }

  updateusersession(id: any, session: any, ids: any): Observable<any> {
    return this.http.post(`${API_URL}/updatesession`, {ids: id, sessionid: session, idsession: ids}, { responseType: 'text' });
  }

  updateusersessionAmount(id: any, session: any, ids: any): Observable<any> {
    return this.http.post(`${API_URL}/updatesessionamount`, {sessionid: session, idsession: ids}, { responseType: 'text' });
  }

  updateuser(value: any): any {
    return this.http.put(`${API_URL}/updateuser`, value);
  }

  disabledaccount(id: any, statu: any): any {
    return this.http.post(`${API_URL}/disable`, {accountid: id, status: statu});
  }

  checkloginname(name: any): any {
    return this.http.get(`${API_URL}/checkaccountexist/${name}`);
  }

  updateSignature(personnelId: string, signature: string): Observable<any> {
    return this.http.put(`${API_URL}/account/signature/${personnelId}`, { signature });
  }

  getaccountinfobyid(id: any): any {
    return this.http.get(`${API_URL}/getuserinfo/${id}`);
  }

  deleteaccount(id: any): any {
    return this.http.post(`${API_URL}/delete`, {accountid: id});
  }

  updatepassword(id: any, pass: any): any {
    return this.http.post(`${API_URL}/updatepassword`, {accountid: id, password: pass});
  }
  checkpassword(id: any, pass: any): any {
    return this.http.post(`${API_URL}/checkpassword`, {accountid: id, password: pass});
  }

  getCriteriaSearch(criteria: any, page = 0, size = 10, sort = 'creaiondate', direction = 'desc'): any {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('direction', direction);
      
    Object.keys(criteria).forEach(key => {
      if (criteria[key] !== null && criteria[key] !== undefined && criteria[key] !== '') {
        params = params.set(key, criteria[key]);
      }
    });

    return this.http.get(`${API_URL}/account/criteria`, { params });
  }

}